import { useState } from "react";
import { Check, ChevronDown } from "lucide-react";

export const CandidateCard = ({ c, index, selected, onPick, disabled }) => {
  const [open, setOpen] = useState(false);
  return (
    <article data-testid={`candidate-card-${index}`}
      className={`surface rounded-2xl p-5 flex flex-col gap-4 fade-up ${selected ? "!border-[var(--q)] ring-1 ring-[var(--q)]" : ""}`}
      style={{ animationDelay: `${index * 70}ms` }}>
      <div className="flex items-center justify-between gap-2">
        <span className="font-mono-data text-xs text-q">{c.rujukan}</span>
        {c.sumber !== "ai" && <span className="eyebrow !text-[10px] px-2 py-1 rounded-full bg-v-soft !text-v" data-testid={`candidate-own-tag-${index}`}>{c.sumber === "rantaian" ? "Dari rantaian" : "Dari kajian anda"}</span>}
      </div>
      <p className="arabic !text-[24px] md:!text-[28px] line-clamp-4" lang="ar" dir="rtl">{c.arab}</p>
      <div>
        <p className={`text-sm text-ink/90 leading-relaxed ${open ? "" : "line-clamp-5"}`}>{c.terjemahan}</p>
        <button onClick={() => setOpen(!open)} className="text-xs text-mute mt-1 inline-flex items-center gap-1 hover:text-ink" data-testid={`candidate-expand-${index}`}>
          {open ? "Ringkaskan" : "Baca penuh"} <ChevronDown size={12} className={open ? "rotate-180" : ""} />
        </button>
      </div>
      {c.kenapa && (
        <div className="rounded-xl bg-q-soft p-3">
          <div className="eyebrow !text-q mb-1">Kenapa</div>
          <p className="text-sm text-ink leading-relaxed">{c.kenapa}</p>
        </div>
      )}
      <button onClick={() => onPick(c)} disabled={disabled} data-testid={`candidate-pick-${index}`}
        className={`mt-auto h-11 rounded-full font-semibold text-sm inline-flex items-center justify-center gap-2 transition-opacity disabled:opacity-40 ${selected ? "bg-q text-bg" : "bg-ink text-bg hover:opacity-90"}`}>
        {selected ? <><Check size={15} /> Dipilih</> : "Pilih ayat ini"}
      </button>
    </article>
  );
};
